import React, { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { isWishlisted, toggleWishlist } from "../lib/store";
import { toast } from "sonner";

export const WishlistButton = ({ handle, withLabel = false, className = "" }) => {
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const sync = () => setSaved(isWishlisted(handle));
    sync();
    window.addEventListener("rj-wishlist", sync);
    return () => window.removeEventListener("rj-wishlist", sync);
  }, [handle]);

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const s = toggleWishlist(handle);
    toast.success(s ? "Saved to your wishlist ♥" : "Removed from wishlist");
  };

  if (withLabel) {
    return (
      <button
        type="button"
        onClick={onClick}
        data-testid="wishlist-toggle-btn"
        className={`inline-flex items-center justify-center gap-2 border tracking-[0.12em] uppercase text-xs h-11 w-full transition-colors duration-300 ${
          saved
            ? "border-[#b04a3a] text-[#b04a3a] bg-[#b04a3a]/5"
            : "border-[#d8cdb5] text-[#5c5240] hover:border-[#b04a3a] hover:text-[#b04a3a]"
        } ${className}`}
      >
        <Heart size={14} className={saved ? "fill-current" : ""} />
        {saved ? "Saved to Wishlist" : "Save to Wishlist"}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={saved ? "Remove from wishlist" : "Save to wishlist"}
      data-testid="wishlist-heart-btn"
      className={`h-9 w-9 flex items-center justify-center rounded-full bg-white/90 backdrop-blur border border-[#ece5d5] shadow-sm hover:scale-110 transition-transform duration-200 ${className}`}
    >
      <Heart size={15} className={saved ? "fill-[#b04a3a] text-[#b04a3a]" : "text-[#7a7160]"} />
    </button>
  );
};

export default WishlistButton;
